import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/IntroSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/LandingSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/Navigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SkillSection/index.tsx");
